export function getResultExampleValue(_ref) {
  let {
    collectionIndex,
    selectionIndex,
    spreadsheetSelections,
    fallback,
    valueIndex = -1
  } = _ref;
  const selectionResults = (spreadsheetSelections[collectionIndex] || [])[selectionIndex] || {
    data: []
  }; // Defaults to fallback when
  // results have not yet populated
  // for the given selection

  return (selectionResults.data[valueIndex] || selectionResults.data[selectionResults.data.length - 1] || {
    value: fallback
  }).value;
}
export function getResultExampleLabel(_ref2) {
  let {
    collectionIndex,
    selectionIndex,
    spreadsheetSelections,
    fallback,
    useValueAsLabel = false
  } = _ref2;
  const selectionResults = (spreadsheetSelections[collectionIndex] || [])[selectionIndex] || {
    data: []
  }; // Defaults to fallback when
  // results have not yet populated
  // for the given selection

  return `${(selectionResults.data[0] || {})[useValueAsLabel ? 'value' : 'label'] || fallback}`;
} // Lookup selection result item from workbook
// or spreadsheet, by flattened selection index
// Used to provide example values for templating

export function getSelectionGroupItemByIndex(flattendSelectionResults, flattenedIndex) {
  let dataIndex = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
  const resultsForSelection = flattendSelectionResults.filter(_ref3 => {
    let {
      selectionIndex
    } = _ref3;
    return selectionIndex === flattenedIndex;
  });
  const firstSelectionGroup = resultsForSelection[0] || {
    data: []
  };
  return firstSelectionGroup.data[dataIndex] || {};
} // Determine if a section has any selection

export function sectionHasSelections(selections) {
  return ((selections || [])[0] || []).length > 0;
}